export class ShareholderCategoryItemModel {
    description: string;
    numberOfShareholders: number;
    numberOfShares: number;
    children: ShareholderCategoryItemModel[] = [];

    constructor(init?: Partial<ShareholderCategoryItemModel>) {
        Object.assign(this, init);
    }
}
